import tokenVerifiedList from 'configs/tokenVerifiedList.json';

export const NETWORK_ICON_LOGO = 'network-icon';

export type TokenVerifiedListItem = {
  address: string;
  symbol: string;
  logoUrl: string;
};

const TOKEN_VERIFIED_LIST = tokenVerifiedList as Array<TokenVerifiedListItem>;

export function findTokenVerifiedListItem(tokenAddress: string): TokenVerifiedListItem | null {
  const normalizedAddress = tokenAddress.toLowerCase();

  return TOKEN_VERIFIED_LIST.find((item) => item.address.toLowerCase() === normalizedAddress) ?? null;
}

export function isNetworkIconLogo(logoUrl: string): boolean {
  return logoUrl === NETWORK_ICON_LOGO;
}
